import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // map from puzzle id to puzzle answer hash. this gets loaded into puzzle
    // run hash.js locally to generate hashes

    // using bcrypt because argon2 doesn't have a salted js version yet?
    hashes: {
      '1': '$2a$10$b57zvoEx3FA5IFeMrbbC9.A7TUW2RDU82g8OaUQwluYBkBeLruAqC',
      '2': '$2a$10$7NPRXWQRmoJvcNvFwrRGkeXymsjdJTi09q5kBIqKGMmvc2/qQ7Sa2',
      '3': '$2a$10$jq5nHmdZKIU01eDFvM82z.20UgA311h.un8n6KvYPQ8z1gVkOOxz6',
      '4': '$2a$10$ypOSJZ2AiT7Wc2qj97Z0UO9j2.3oK1oo3F/pJDKKXnWPsOPAtM2F.',
      '5': '$2a$10$4hK7Yc6qHDktx16LQV26GOPcX4y2WU/cczjh85lJw/wENtOf10sXm',
      w1: '$2a$10$eqDxtAh.s5rNuUmuvJdOUuFpQ50c5sU6/mh/kwgM76VFJ/JF921Uq',
      w2: '$2a$10$8IYodTSS6Q/1SqZS99Jf8OY7tv/VMvs5topOc10FYSCfftiw9yjd.',
      meta: '$2a$10$9dZzRvWyhRQKUC9U.SGF3u80jSu6Qn6gm83czf128MUNcaalaMMd6',
    }
    ,
    answers: {
      'w1': 'genome',
      'w2': 'poem',
      '1': 'beetle',
      '2': 'universal',
      '3': 'deaf',
      '4': 'negative',
      '5': 'continental',
      'meta': 'turing incomplete',
      // 'm1': 'continental',
      // 'm2': 'deaf',
      // 'm3': 'universal',
      // 'm4': 'beetle',
      // 'm5': 'negative',
      
      // 'm6': 'botanical',
      // 'm7': 'drugstore',
      // 'm8': 'perimeter',
      // 'm9': 'quintuple',
    }
    ,
    meta: {
      'meta-1': {
        'meta-1-wegener': {
          placeholder: 'Wegener\'s favourite word',
          hash: '$2a$10$DJivpXLUPDPsI.6ePY.RW..8SoG09Qd1UpPy7geciAl0fTjLIwMAi',
        },
        'meta-1-gogh': {
          placeholder: 'van Gogh\'s favourite word',
          hash: '$2a$10$kV0RYskM0yln/JgBeavMDuSuL1tisEaplTas1umVn7w4m27OvicHq',
        },
        'meta-1-galilei': {
          placeholder: 'Galilei\'s favourite word',          
          hash: '$2a$10$JFjk8h1ea.DpKDtGrgWOh.tSN9pcgquwTmJw4Gs56vd5xF6gpDqLW',
        },
        'meta-1-kafka': {
          placeholder: 'Kafka\'s favourite word',
          hash: '$2a$10$xv9E7LZK3q3lut7jhdopa.VjUQf.sSAtu7hwUpehNdyQhZ/qAOz8i',
        },
        'meta-1-maier': {
          placeholder: 'Maier\'s favourite word',
          hash: '$2a$10$Naj7DkOlfqaAoG3SzYNRAeFH/yj77XPkmgXac1Xct4AQaSDmNE4Vm',
        }
      },
      'meta-2': {
        'meta-2-explosive': {
          placeholder: 'The Explosive Roleplayers\' enigmatic word',
          hash: '$2a$10$3oXp/qKQhd2.kySly6RYZ.W0DRenuehLv2vnitCNdy.iDJ6EgJHaS',
        },
        'meta-2-free' : {
          placeholder: 'The Free Marketeers\' enigmatic word',
          hash: '$2a$10$C5HsobeX.r8viGvwZV5yzeeJr4THrck9Ryw2AVk3ph5vVkRXd.vcm',
        },
        'meta-2-wordplay' : {
          placeholder: 'The Wordplay Duo\'s enigmatic word',
          hash: '$2a$10$MoSypsI1IJYvlBis7WoEp.rLbVsP2SnWfYsOYXUltPPTSdmeki.F.',
        },
        'meta-2-lorem': {
          placeholder: 'The L0r3m 1p5um Tryhards\' enigmatic word',
          hash: '$2a$10$oA0PZt71b/bvFyFyr0JwQu6P5Ez6P1Z5r9dprRDKIi0WJwo96l1UC'
        }
      }
    }
    ,
    puzzles: [
      {
        id: 'w1',
        name: 'warmup 1. gregor mendel (1 pt)',
        flavor: "Gregor Mendel can't stop playing this phone game, but he's stuck on this generation... can you help him?",
      },
      {
        id: 'w2',
        name: 'warmup 2. emily dickinson (1 pt)',
        flavor: "Little known fact: Emily Dickinson loved haikus and word squares.",
      },
      {
        id: 1,
        name: 'puzzle 1. transform (5 pts)',
        flavor: "This little puzzle transformed all these examples! If only I knew how it worked...",
      },
      {
        id: 2,
        name: 'puzzle 2. draw, please (5 pts)',
        flavor: 'These shapes need to return to their families, but the border rules keep changing! It\'s a good thing their shape detector relies on extremely basic heuristics.. Help them disguise as other shapes to get home.',
      },
      {
        id: 3,
        name: 'puzzle 3. bubble lottery (5 pts)',
        flavor: "Even a phantom limb can play games to sort straws! Let's find out who gets what.",
      },
      {
        id: 4,
        name: 'puzzle 4. getting physical (5 pts)',
        flavor: "Oh great, crossword clues with no grid... find the grid and follow where it goes.",
      },
      {
        id: 5,
        name: 'puzzle 5. connect (5 pts)',
        flavor: "A word mystery: what's at the centre of it all?",
      },
      {
        id: 'meta',
        name: 'the enigmeta machine (100 pts)',
        flavor: '',
      },
    ],

  },
  mutations: {
    // initialize answer hashes from the answer object
    initAnswers (state) {
      state.puzzles.forEach(puzzle => {
        puzzle.hash = state.hashes[puzzle.id]
        puzzle.ans = state.answers[puzzle.id] // plaintext ans for solution pages
      })
    }
  },
  actions: {

  }
})
